import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'transformLink',
})
export class TransformTextInHiperlinkPipe implements PipeTransform {
  transform(text: any): any {
    const hasHtmlTags = /<\/?[^>]+(>|$)/g;

    if (text && !text.match(hasHtmlTags)) {
      let urlRegex =
        /(\b(https?|ftp):\/\/[A-Z0-9+&@#\/%?=~_|!:,.;-]*[-A-Z0-9+&@#\/%=~_|])/gim;
      let emailRegex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi;
      let urlTag =
        '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>';
      let emailTag = '<a href="mailto:$&">$&</a>';

      if (text && text.match(urlRegex)) {
        text = text.replace(urlRegex, urlTag);
      }
      if (text && text.match(emailRegex)) {
        text = text.replace(emailRegex, emailTag);
      }
    }

    return text;
  }
}
